export default __webpack_public_path__ + "static/media/hide_nav_icon_green.fe8b1a95.svg";